<template>
    <div class="projectPassage_wrap">
        <div class="passage" @click="enterDetailsPage(item.id)" v-for="item in articleList" :key="item.id">
            <img :src="item.imageUrl" alt="" />
            <div class="passage_logo" @click="enterDetailsPage(item.id)">
                <span>进入专题</span>
                <i class="el-icon-arrow-right"></i>
            </div>
            <div class="passage_content">
                <span>{{item.title}}</span>
                <p class="passage_p">
                    {{item.description}}
                </p>
                <p>共{{item.articleNum}}篇</p>
            </div>
        </div>
    </div>
</template>

<script>
import { articleSubject } from '../../utils/api';

export default {
    data() {
        return {
            articleList:[]
        };
    },
    mounted(){
        this.getArticleSubject()
    },
    methods: {
        //获取专题栏目
        getArticleSubject(){
            articleSubject().then(res => {
                this.articleList = res.data;
            }).catch(err=>{})
        },

        //单击进入文章专题页
        enterDetailsPage(id){
            this.$router.push({path:'/cloudClassroomProject',query:{subjectId:id}})
        }
    }
};
</script>

<style lang="scss" scoped>
.projectPassage_wrap {
    width: calc(100% - 400px);
    // height: 310px;
    margin-left: 200px;
    .passage {
        height: 300px;
        background: #fff;
        box-shadow: 0px 3px 12px rgba(189, 204, 255, 0.3);
        margin-top: 20px;
        color: #3C3C3C;
        img {
            position: relative;
            display: block;
            width: 300px;
            height: 240px;
            top: 35px;
            left: 40px;
        }
        .passage_content {
            // background: white;
            height: 220px;
            margin-top: -200px;
            width: calc(100% - 600px);
            margin-left: 380px;
            span {
                color: #5278f7;
                font-weight: 600;
                font-size: 26px;
                padding-top: 10px;
            }
            p {
                margin: 40px 0;
            }
            .passage_p {
                color: rgba(33,33,33,0.6);
                font-size: 20px;
                line-height: 2;
            }
        }
        .passage_logo {
            position: relative;
            left: 1400px;
            top: -180px;
        }
        .passage_logo:hover {
            color: #ff6206;
        }
    }
    .passage:hover {
        background: #FFFFFF;
        box-shadow: 0px 3px 12px rgba(171, 185, 230, 0.3);
        opacity: 0.8;
        cursor: pointer;
    }
}
.projectPassage_wrap div:nth-child(1) {
    margin-top: 64px;
}
.projectPassage_wrap div:last-child {
    margin-bottom: 140px;
}
</style>
